// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3_jhV","detailsBorder":"styles_detailsBorder__Bdiqo"};